import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./styles/styles.scss";

import Header from "./components/Header";
import Slider from "./components/Slider";
import Main from "./components/Main";
import Footer from "./components/Footer";
import WhatsAppFlotante from "./components/WhatsAppFlotante/WhatsAppFlotante";

import Error404 from "./components/404";

import TagManager from "react-gtm-module";
import { useHistory } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { AppProvider } from "./config/ToSendProvider";

// const tagManagerArgs = {
//   gtmId: "GTM-WLNPNS6",
// };

// TagManager.initialize(tagManagerArgs);

function App() {
  // window.dataLayer.push({
  //   event: "pageview",
  // });

  return (
    <AppProvider>
      <Router basename="/montironi-jeep">
        <ScrollToTop />
        <Switch>
          <Route exact path="/:tipo?">
            <Header />
            <Slider />
            <Main />
            <Footer />
            <WhatsAppFlotante />
          </Route>

          <Route path="*">
            <Error404 />
          </Route>
        </Switch>
      </Router>
    </AppProvider>
  );
}

export default App;
